import { getActionFromUrl, ModalRenderedDetail } from "../initializer";
import { luscinia } from "../luscinia";
import { Bootgrid } from "./bootgrid";
import { deleteRecords } from "../record";
import { getFilter } from "./bootgridFilter";

export function newRecordHandler(bootgrid: Bootgrid) {
    const dataNewModalUrl = bootgrid.$bootgrid.data("new-record-modal-url");
    if (dataNewModalUrl) {
        luscinia.openCustomModal(dataNewModalUrl)
    }
    else {
        return luscinia.openNewRecordModal(bootgrid.$bootgrid, luscinia.config);
    }
}

export function editRecordHandler(bootgrid: Bootgrid, recordId: string): JQuery.jqXHR {
    const menuItemId = bootgrid.$bootgrid.data(luscinia.data.menuItemId);
    const layerId = luscinia.getModalLayerCount();
    const modalIdentifier = "#editModal" + layerId;

    let url = bootgrid.$bootgrid.data(luscinia.data.modalUrl);
    if (url === undefined || url === "") {
        url = bootgrid.$bootgrid.data(luscinia.data.baseUrl);
    }

    url = url + "/modaledit?action=edit&id=" + recordId + "&bootgridId=bootGrid" + menuItemId + "&layerid=" + layerId;
    return $.get(url, (data) => {
        $("#cl-wrapper").append(data);
        luscinia.initModalDialog($(modalIdentifier + "Form"), modalIdentifier, luscinia.config, getActionFromUrl(url));
        $(modalIdentifier).modal("show");
        $(modalIdentifier + ' .modal-body :input:enabled:visible:first').focus();

        document.dispatchEvent(new CustomEvent<ModalRenderedDetail>('modalRendered', {
            detail: {
                recordTableName: bootgrid.$bootgrid.get(0).dataset.lusciniaTablename,
                modalIdentifier: modalIdentifier,
            }
        }));
    }).fail(function () {
        luscinia.showNotification(luscinia.config.translations.captionNotification, luscinia.config.translations.captionNotificationForbidden, "danger");
    })
}

export async function deleteRecordHandler(bootgrid: Bootgrid, recordIds: string[]) {
    var url = bootgrid.$bootgrid.data(luscinia.data.modalUrl);
    if (url === undefined || url === "") {
        url = bootgrid.$bootgrid.data(luscinia.data.baseUrl);
    }

    try {
        await deleteRecords(url, recordIds, () => (bootgrid.$bootgrid as any).bootgrid("reload"));
    } catch (error) {
        if (error instanceof Error) {
            luscinia.showNotification(luscinia.config.translations.captionNotification, error.message, "danger");
        } else {
            luscinia.showNotification(luscinia.config.translations.captionNotification, "An unknown error occurred while deleting the error", "danger");
        }
    }
}

export function tableExportHandler(bootgrid: Bootgrid) {
    let menuItemId = bootgrid.$bootgrid.data(luscinia.data.menuItemId);
    let url = bootgrid.$bootgrid.data(luscinia.data.modalUrl);
    if (url === undefined || url === "") {
        url = bootgrid.$bootgrid.data(luscinia.data.baseUrl);
    }
    const filterColumnName = luscinia.data.filterColumnName;
    let parentBootgrid = $("." + luscinia.css.bootgrid + "[data-" + filterColumnName + "='']");
    let rows = parentBootgrid.find("tr." + luscinia.css.rowSelected);

    const downloadFromUrl = (exportUrl: string) => {
        fetch(exportUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(getFilter.call(bootgrid)),
        })
            .then((response) => {
                if (response.ok) {
                    return response.blob();
                } else {
                    throw new Error("Error downloading file");
                }
            })
            .then((blob) => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "export.xlsx";
                a.click();
                URL.revokeObjectURL(url);
            })
            .catch((error) => {
                luscinia.showNotification("An error occurred", "An error occurred while downloading the file.", "danger");
            });
    };

    if ((bootgrid.$bootgrid as any).data(filterColumnName) === "") {
        const exportUrl = url + "/export/" + menuItemId + "?format=excel";
        downloadFromUrl(exportUrl);
    } else {
        const exportUrl = `${url}/export/${menuItemId}/${bootgrid.$bootgrid.data(filterColumnName)}/${$(rows[0]).data("row-id")}?format=excel`;
        downloadFromUrl(exportUrl);
    }
}